import React from 'react';
import PropTypes from 'prop-types';
import { PaginationItem } from './PaginationItem';
import { getRange } from '../../../helpers/utilities';

export const NumberedPagination = ({ data, onPrevious, onNext, onPage, sizeClass, className }) => {
    const pageRange = 1;
    const { page: currentPage, size: pageSize, total: totalRecords } = data;

    const totalPage = Math.ceil(totalRecords / pageSize);
    let rangeStart = currentPage - pageRange;
    let rangeEnd = currentPage + pageRange;

    if (rangeEnd > totalPage) {
        rangeEnd = totalPage;
        rangeStart = totalPage - pageRange * 2;
        rangeStart = rangeStart < 1 ? 1 : rangeStart;
    }

    if (rangeStart <= 1) {
        rangeStart = 1;
        rangeEnd = Math.min(pageRange * 2 + 1, totalPage);
    }

    return (
        <div className={`d-flex justify-content-center ${className}`}>
            <ul
                className={`pagination ${sizeClass}`}
                style={{ display: totalPage > 1 ? 'flex' : 'none' }}>
                <PaginationItem disabled={currentPage === 1} onClick={onPrevious}>
                    <i className="fal fa-angle-left fa-fw"></i>
                </PaginationItem>
                {rangeStart <= 3 &&
                    getRange(1, rangeStart - 1).map((page) => (
                        <PaginationItem
                            key={page}
                            page={page}
                            active={page === currentPage}
                            onClick={() => onPage(page)}
                        />
                    ))}
                {rangeStart > 3 && (
                    <React.Fragment>
                        <PaginationItem
                            page={1}
                            active={currentPage === 1}
                            onClick={() => onPage(1)}
                        />
                        <PaginationItem disabled={true}>...</PaginationItem>
                    </React.Fragment>
                )}
                {getRange(rangeStart, rangeEnd).map((page) => (
                    <PaginationItem
                        key={page}
                        page={page}
                        active={page === currentPage}
                        onClick={() => onPage(page)}
                    />
                ))}
                {rangeEnd >= totalPage - 2 &&
                    getRange(rangeEnd + 1, totalPage).map((page) => (
                        <PaginationItem
                            key={page}
                            page={page}
                            active={page === currentPage}
                            onClick={() => onPage(page)}
                        />
                    ))}
                {rangeEnd < totalPage - 2 && (
                    <React.Fragment>
                        <PaginationItem disabled={true}>...</PaginationItem>
                        <PaginationItem
                            page={totalPage}
                            active={currentPage === totalPage}
                            onClick={() => onPage(totalPage)}
                        />
                    </React.Fragment>
                )}
                <PaginationItem disabled={currentPage === totalPage} onClick={onNext}>
                    <i className="fal fa-angle-right fa-fw"></i>
                </PaginationItem>
            </ul>
        </div>
    );
};

NumberedPagination.propTypes = {
    sizeClass: PropTypes.string,
    className: PropTypes.string,
    onPrevious: PropTypes.func,
    onNext: PropTypes.func,
    onPage: PropTypes.func,
    data: PropTypes.object
};

NumberedPagination.defaultProps = {
    sizeClass: '',
    className: '',
    onPrevious: () => {},
    onNext: () => {},
    onPage: () => {},
    data: null
};
